import { BaseRender } from "../../../core/render/BaseRender";
import { BatchRender } from "./BatchRender";

export class StatiVertexMergeBatchRender extends BatchRender {
    
    //TODO 好像基类不需要
    _addList(renderNodes: BaseRender[]) {
        //TODO  add list
    }
}